import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import images from '../../../assets/images';
import styles from '../../../assets/css/vendors/vendors.module.css';

const CreateForm = ({ children, step, handleSubmit, steps, view }) => {
    const [formData, setFormData] = useState([]);
    let count = 1;
    const lengthData = steps.length;
    const updateValuesRefs = (data, value) => {
        value.checkRefs.current.forEach(element => {
            element.values
                ? (element.values = element.values + ',' + data)
                : (element.values = data);
        });
    };
    const selectedCheckbox = (i, name, value, index, step) => {
        if (value.checkRefs.current[i].checked) {
            value.checkRefs.current[i].selected = true;
            value.checkRefs.current[i].name = name;
            value.checkRefs.current[i].nameSelect = value.name;
            updateValuesRefs(name, value);
        } else {
            const data = value.checkRefs.current[i].values
                ? value.checkRefs.current[i].values.split(',')
                : step.myRefs.current[index].value.split(',');
            const newDataRef = data.filter(item => item !== name);
            value.checkRefs.current[i].selected = false;
            value.checkRefs.current[i].removeAttribute('checked');
            value.checkRefs.current[i].name = '';
            value.checkRefs.current.forEach(element => {
                element.values = newDataRef.toString();
            });
            value.checkRefs.current[i].values = newDataRef.toString();
            value.checkRefs.current[i].checked = false;
        }
        step.myRefs.current[index].value = value.checkRefs.current[i].values;
    };

    const isNumber = (event, value) => {
        if (
            isNaN(parseInt(event.key, 10)) &&
            event.key !== 'Backspace' &&
            event.key !== 'Enter'
        ) {
            value.value = '';
            event.preventDefault();
        } else {
            value.value = event.target.value;
        }
    };
    const Selectors = data => {
        const { index, value, step } = data;
        return (
            <div className={`${styles.list_container}`}>
                {value.data.map((val, i) => {
                    return (
                        <div
                            className={`${styles.checkboxs} ${
                                value.checkRefs.current[i]?.selected
                                    ? styles.checked
                                    : ''
                            }`}
                            key={i}>
                            <input
                                ref={el => (value.checkRefs.current[i] = el)}
                                type="checkbox"
                                onClick={state =>
                                    selectedCheckbox(
                                        i,
                                        val.name,
                                        value,
                                        index,
                                        step
                                    )
                                }
                            />
                            <span className={styles.checked_item}>
                                {val.name}
                            </span>
                        </div>
                    );
                })}
            </div>
        );
    };
    const validateSelected = () => {
        steps.forEach(element => {
            element.formList.forEach(value => {
                if (value.type === 'select') {
                    const selected = document.getElementById(value.name);
                    value.data.forEach((val, i) => {
                        selected?.value.includes(val.name) &&
                            (value.checkRefs.current[i].checked = true);
                        selected?.value.includes(val.name) &&
                            (value.checkRefs.current[i].selected = true);
                    });
                }
            });
        });
    };

    const selected = (index, value, id, imageId) => {
        console.log('ooooo', imageId);
        const element = document.getElementById(id);
        const img = document.getElementById(imageId);
        element.style.display =
            element.style.display === 'none' ? 'block' : 'none';
        img.src =
            element.style.display === 'none'
                ? images.arrowUp
                : images.arrowDown;
        value.current[index].selected = !value.current[index].selected;
    };

    useEffect(() => {
        const array = [];
        const list = [];
        steps.forEach(element => {
            element.formList.forEach(value => {
                if (value.type === 'select') {
                    list.push({
                        listelements: value.checkRefs.current
                    });
                }
            });
            array.push({ textelemnts: element.myRefs });
        });
        setFormData(data => [...formData, array]);
    }, [steps]);

    return (
        <div className={styles.container}>
            <form
                className={`${styles.form_login} ${
                    view ? styles.container : styles.login_create_vendor
                }`}
                onSubmit={handleSubmit}>
                {steps.map((val, key) => {
                    count === lengthData
                        ? setTimeout(() => {
                              validateSelected();
                          }, 500)
                        : count++;
                    if (val.view) {
                        return key === step ? val.view : <></>;
                    } else {
                        return steps[key].formList.map((value, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <label
                                        className={`${styles.labelLeft} ${
                                            styles.display_none
                                        } ${key === step && styles.display}`}>
                                        {value.label}
                                        {value.required && <span>*</span>}
                                    </label>
                                    {value.type !== 'select' ? (
                                        <div
                                            className={`${
                                                styles.contentSelect
                                            } ${styles.display_none} ${
                                                key === step && styles.display
                                            }`}>
                                            {value.code && (
                                                <>
                                                    <input
                                                        ref={el =>
                                                            (steps[
                                                                key
                                                            ].myRefs.current[
                                                                steps[
                                                                    key
                                                                ].formList.length
                                                            ] = el)
                                                        }
                                                        placeholder={value.code}
                                                        className={
                                                            styles.code_number
                                                        }
                                                        size={2}
                                                        maxLength={2}
                                                        name={
                                                            value.name + 'code'
                                                        }
                                                        onKeyUp={e =>
                                                            isNumber(
                                                                e,
                                                                steps[key]
                                                                    .myRefs
                                                                    .current[
                                                                    steps[key]
                                                                        .formList
                                                                        .length
                                                                ]
                                                            )
                                                        }
                                                    />
                                                    <span
                                                        className={styles.plus}>
                                                        +
                                                    </span>
                                                </>
                                            )}
                                            <input
                                                ref={el =>
                                                    (steps[key].myRefs.current[
                                                        index
                                                    ] = el)
                                                }
                                                type={value.type}
                                                id={value.name}
                                                name={value.name}
                                                placeholder={value.placeholder}
                                                className={styles.marginBottom}
                                            />
                                        </div>
                                    ) : (
                                        <>
                                            <div
                                                className={`${
                                                    styles.contentSelect
                                                } ${styles.display_none} ${
                                                    key === step &&
                                                    styles.display
                                                }`}>
                                                <input
                                                    ref={el =>
                                                        (steps[
                                                            key
                                                        ].myRefs.current[
                                                            index
                                                        ] = el)
                                                    }
                                                    type={value.type}
                                                    id={value.name}
                                                    name={value.name}
                                                    placeholder={
                                                        value.placeholder
                                                    }
                                                    className={
                                                        styles.marginBottom
                                                    }
                                                    onClick={() =>
                                                        selected(
                                                            index,
                                                            steps[key].myRefs,
                                                            value.name +
                                                                '_list',
                                                            value.name +
                                                                '_arrow'
                                                        )
                                                    }
                                                />
                                                <div
                                                    className={styles.arrow_up}>
                                                    <img
                                                        id={
                                                            value.name +
                                                            '_arrow'
                                                        }
                                                        src={images.arrowUp}
                                                        alt="arrowUp"
                                                        className={
                                                            styles.iconArrow
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                id={value.name + '_list'}
                                                style={{ display: 'none' }}>
                                                <Selectors
                                                    index={index}
                                                    value={value}
                                                    step={steps[key]}
                                                />
                                            </div>
                                        </>
                                    )}
                                </React.Fragment>
                            );
                        });
                    }
                })}

                {children}
            </form>
        </div>
    );
};
CreateForm.propTypes = {
    children: PropTypes.node.isRequired,
    view: PropTypes.bool,
    handleSubmit: PropTypes.func,
    steps: PropTypes.array,
    step: PropTypes.number
};

export default CreateForm;
